import { DarkFaEdit } from '../DarkFaEdit';
import React, { ReactNode } from 'react';
import { FlexRow, NavigationItem, SmallBodyText, BoldHeader5Text } from 'ui-toolkit';
import { ISummaryItemProps } from '../../../../shared/Summary/SummaryItem/SummaryItem';
import { StyledSummaryItem } from '../../../../shared/Summary/SummaryItem/SummaryItem.styles';
import { useShouldSummaryItemRender } from '../../../../shared/Summary/useShouldSummaryItemRender';

interface IPartySummaryDropdownProps extends ISummaryItemProps {
  children: ReactNode;
  onClick?: (href?: string) => void;
}

export const PartySummaryDropdown = ({ children, label, onClick }: IPartySummaryDropdownProps) => {
  const shouldRender = useShouldSummaryItemRender(label, 'parties');
  if (!shouldRender) {
    return null;
  }
  return (
    <StyledSummaryItem>
      <FlexRow justifyContent={'space-between'}>
        <BoldHeader5Text>{label}</BoldHeader5Text>
        <NavigationItem text={`Edit ${label}`} onClick={onClick}>
          <DarkFaEdit />
        </NavigationItem>
      </FlexRow>
      <SmallBodyText>{children}</SmallBodyText>
    </StyledSummaryItem>
  );
};
